
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customerportal",
      function () {
        return require("private-next-pages/customerportal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customerportal"])
      });
    }
  